
export default interface AnalyticsEvent {
    name: string;
    properties?: Record<string, any>;
    timestamp?: number;
}

export type ErrorDetails = {
    message: string;
    stack?: string;
    componentStack?: string;
    metadata?: Record<string, any>;
    userId?: string;
    sessionId?: string;
};

export enum Event {
    ENTER_SCREEN,
    EXIT_SCREEN,
    ACTION_BUTTON_CLICK
}